/** Regioni italiane — bounding box approssimativi per highlight e filtri */

export const MACRO_ZONE = {
  nord: { label: 'Nord', color: '#4a90d9' },
  centro: { label: 'Centro', color: '#c78244' },
  sud: { label: 'Sud', color: '#e8a838' },
  isole: { label: 'Isole', color: '#6b9e78' },
};

export const TIPO_LABELS = {
  fresco: 'Fresco',
  secco: 'Secco',
  fragile: 'Fragile',
};

export const REGIONI = [
  { id: 'valle-aosta', nome: "Valle d'Aosta", macro: 'nord', latMin: 45.5, latMax: 45.95, lngMin: 6.9, lngMax: 7.9 },
  { id: 'piemonte', nome: 'Piemonte', macro: 'nord', latMin: 44.0, latMax: 46.5, lngMin: 6.6, lngMax: 9.2 },
  { id: 'liguria', nome: 'Liguria', macro: 'nord', latMin: 43.8, latMax: 44.7, lngMin: 7.5, lngMax: 10.1 },
  { id: 'lombardia', nome: 'Lombardia', macro: 'nord', latMin: 44.8, latMax: 46.5, lngMin: 8.5, lngMax: 11.5 },
  { id: 'trentino', nome: 'Trentino', macro: 'nord', latMin: 45.4, latMax: 47.1, lngMin: 10.4, lngMax: 12.3 },
  { id: 'veneto', nome: 'Veneto', macro: 'nord', latMin: 44.8, latMax: 46.7, lngMin: 10.6, lngMax: 13.0 },
  { id: 'friuli', nome: 'Friuli-V.G.', macro: 'nord', latMin: 45.5, latMax: 46.7, lngMin: 12.4, lngMax: 13.9 },
  { id: 'emilia', nome: 'Emilia-Romagna', macro: 'nord', latMin: 43.7, latMax: 45.2, lngMin: 9.2, lngMax: 12.8 },
  { id: 'toscana', nome: 'Toscana', macro: 'centro', latMin: 42.2, latMax: 44.5, lngMin: 9.6, lngMax: 12.4 },
  { id: 'umbria', nome: 'Umbria', macro: 'centro', latMin: 42.4, latMax: 43.6, lngMin: 11.9, lngMax: 13.3 },
  { id: 'marche', nome: 'Marche', macro: 'centro', latMin: 42.6, latMax: 43.9, lngMin: 12.3, lngMax: 13.9 },
  { id: 'lazio', nome: 'Lazio', macro: 'centro', latMin: 41.2, latMax: 42.8, lngMin: 11.5, lngMax: 13.8 },
  { id: 'abruzzo', nome: 'Abruzzo', macro: 'centro', latMin: 41.7, latMax: 42.9, lngMin: 13.3, lngMax: 14.8 },
  { id: 'molise', nome: 'Molise', macro: 'centro', latMin: 41.4, latMax: 42.0, lngMin: 14.0, lngMax: 15.0 },
  { id: 'campania', nome: 'Campania', macro: 'sud', latMin: 40.0, latMax: 41.5, lngMin: 13.8, lngMax: 15.8 },
  { id: 'puglia', nome: 'Puglia', macro: 'sud', latMin: 39.8, latMax: 42.0, lngMin: 15.0, lngMax: 18.5 },
  { id: 'basilicata', nome: 'Basilicata', macro: 'sud', latMin: 39.9, latMax: 40.9, lngMin: 15.4, lngMax: 16.6 },
  { id: 'calabria', nome: 'Calabria', macro: 'sud', latMin: 38.0, latMax: 40.2, lngMin: 15.6, lngMax: 17.2 },
  { id: 'sicilia', nome: 'Sicilia', macro: 'isole', latMin: 36.6, latMax: 38.3, lngMin: 12.4, lngMax: 15.7 },
  { id: 'sardegna', nome: 'Sardegna', macro: 'isole', latMin: 38.8, latMax: 41.3, lngMin: 8.1, lngMax: 9.8 },
];

export function regioneDaCoordinate(lat, lng) {
  if (!lat || !lng) return null;
  for (const r of REGIONI) {
    if (lat >= r.latMin && lat <= r.latMax && lng >= r.lngMin && lng <= r.lngMax) {
      return { id: r.id, nome: r.nome, macro: r.macro, lat, lng };
    }
  }
  const macro = lat >= 43.5 ? 'nord' : lat >= 41.0 ? 'centro' : lat >= 38.5 ? 'sud' : 'isole';
  return { id: null, nome: MACRO_ZONE[macro]?.label || macro, macro, lat, lng };
}

export function macroLabel(macro) {
  return MACRO_ZONE[macro]?.label || macro;
}
